import { Panel } from "../components";
import { REST_DAY_BANK_CAP } from "../engine/streak";
import { profile } from "../state/store";
import { Heatmap } from "./progress/Heatmap";
import { LogbookList } from "./progress/LogbookList";
import { PlaqueGrid } from "./progress/PlaqueGrid";
import { RankLadder } from "./progress/RankLadder";
import { RecordsTable } from "./progress/RecordsTable";

export function ProgressScreen() {
  const p = profile.value;

  return (
    <div class="screen screen-progress">
      <p class="display screen-title">Progress</p>

      <Panel class="progress-block">
        <p class="label">Consistency</p>
        <Heatmap />
        <div class="progress-stats">
          <div class="progress-stat">
            <p class="mono progress-stat-num">{p.streak.current}</p>
            <p class="label">Current streak</p>
          </div>
          <div class="progress-stat">
            <p class="mono progress-stat-num">{p.streak.longest}</p>
            <p class="label">Longest streak</p>
          </div>
          <div class="progress-stat">
            <p class="mono progress-stat-num">
              {p.streak.restDays} / {REST_DAY_BANK_CAP}
            </p>
            <p class="label">Rest days banked</p>
          </div>
          <div class="progress-stat">
            <p class="mono progress-stat-num">{Math.floor(p.seconds / 60)}</p>
            <p class="label">Minutes trained</p>
          </div>
        </div>
      </Panel>

      <Panel class="progress-block">
        <p class="label">Rank ladder</p>
        <RankLadder />
      </Panel>

      <Panel class="progress-block">
        <p class="label">Records</p>
        <RecordsTable />
      </Panel>

      <Panel class="progress-block">
        <p class="label">Plaque cabinet</p>
        <PlaqueGrid />
      </Panel>

      <Panel class="progress-block">
        <p class="label">Logbook</p>
        <LogbookList entries={p.log} />
      </Panel>
    </div>
  );
}
